<template>
  <pui-flex class="pui-file-notification" direction="column" flex="1">
    <!-- DOWNLOAD IN PROGRESS -->
    <template v-if="data.state === DownloadStates.DOWNLOADING">
      <pui-flex class="file-notification-title">
        <div class="notif-title-main">
          <span class="notif-title-main__picto mdi mdi-clock-outline"></span>
          {{ $t('dam.files.download.notification.start.title') }}
        </div>
      </pui-flex>
      <div class="file-notification-content">
        <pui-common-progress-linear hideMessage />
      </div>
    </template>

    <!-- DOWNLOAD READY -->
    <template v-if="data.state === DownloadStates.READY">
      <pui-flex class="file-notification-title notification-success">
        <div class="notif-title-main">
          <span class="notif-title-main__picto mdi mdi-check-circle-outline"></span>
          {{ $t('dam.files.download.notification.ready.title') }}
        </div>
        <div class="notif-title-secondary">
          <pui-button
            picto="mdi-close"
            flat
            variant="secondary"
            @click.stop="dismissNotification"
          />
        </div>
      </pui-flex>
      <div class="file-notification-content">
        <i18n path="dam.files.download.notification.ready.message_primary">
          <template #link>
            <a :href="data.downloadUrl" download target="_blank">{{$t('dam.files.download.notification.ready.message_link')}}</a>
          </template>
        </i18n>
      </div>
    </template>

    <!-- DOWNLOAD ERROR -->
    <template v-else-if="data.state === DownloadStates.ERROR">
      <pui-flex class="file-notification-title notification-error">
        <div class="notif-title-main">
          <span class="notif-title-main__picto mdi mdi-alert-circle-outline"></span>
          {{ $t('dam.files.download.notification.error.title') }}
        </div>
        <div class="notif-title-secondary">
          <pui-button
            picto="mdi-close"
            flat
            variant="secondary"
            @click.stop="dismissNotification"
          />
        </div>
      </pui-flex>
      <div class="file-notification-content">
        <div>
          {{ $t('dam.files.download.notification.error.message_primary') }}
        </div>
        <div>{{ $t('dam.files.download.notification.error.message_secondary') }}</div>
      </div>
    </template>
  </pui-flex>
</template>

<script>
import services from '../../../../../core/services';
import notificationItemMixin from '../../../../../platform/components/notifications/notificationItemMixin';
import { DownloadStates } from '../../../constants/file';

export default {
  name: 'dam-file-download-notification',
  mixins: [notificationItemMixin],
  data() {
    return {
      DownloadStates,
    };
  },
  methods: {
    // NOTIF ACTIONS
    /**
     * Removes this notification
     *
     * @returns {void}
     */
    dismissNotification() {
      services.getService('notifications').removeNotification(this.id);
    },
  },
};
</script>
